import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import {
  KAMServicing,
  NavLinkList,
  NavLinkList_area_manager,
  NavLinkList_territory_manager,
  NavKAMList,
  NavLinkList__super_user,
  NavLinkList__online_user,
  NavLinkList__cluster_manager,
  NavLinkList__agency_manager,
  NavLinkList__QC,
} from "../../layout/linkConfig";
import { TroubleshootRounded } from "@mui/icons-material";

const isRouteAvailable = (path) => {
  const localUserType = JSON.parse(localStorage.getItem("currUserType"));
  const portalType = JSON.parse(localStorage.getItem("portal"));
  const scope = localStorage.getItem("scope");

  const routeConfig =
    scope === "online"
      ? NavLinkList__online_user
      : localUserType === "bkash_user"
      ? NavLinkList__QC
      : localUserType === "bkash-super-user"
      ? NavLinkList__super_user
      : localUserType === "area_manager"
      ? NavLinkList_area_manager
      : localUserType === "territory_manager"
      ? NavLinkList_territory_manager
      : localUserType === "cluster_manager"
      ? NavLinkList__cluster_manager
      : localUserType === "merchant_management" ||
        localUserType === "trade_merketing"
      ? KAMServicing
      : localUserType === "agency_user"
      ? NavLinkList__agency_manager
      : portalType === "kam"
      ? NavKAMList
      : NavLinkList;

  if (routeConfig.some((e) => e.to === path)) return true;
  return false;
};

const PrivateRoute = ({ component: Component, path: path, ...rest }) => {
  console.log({ component: Component, path: path, ...rest });
  return (
    <Route
      {...rest}
      render={(props) =>
        isRouteAvailable(path) ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
